import { useTranslation } from 'react-i18next'

import Icon from '../icon'

const Copyrights = () => {
  const { t } = useTranslation('common')

  return (
    <div className="text-center text-xs text-txt pb-[50px] px-5 py-0 xl:px-[30px] xl:py-0">
      <div className="flx-ctr gap-3 hidden mb-6 xl:flex">
        <div className="flex">
          <Icon className="fill-txt" id="18-plus" width="38" height="38" />
        </div>
        <p className="text-txt text-sm xl:text-base">{t('18-plus')}</p>
      </div>
      <p style={{ marginBottom: '15px' }}>{t('copyright')}</p>
    </div>
  )
}

export default Copyrights
